import React, { useState } from "react";
import {
  Drawer,
  Button,
  Typography,
  IconButton,
  TextField,
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const CartDrawer = () => {
  const [open, setOpen] = useState(false);
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      price: 100.9,
      originalPrice: 160,
      image: "/carousel/car1.png",
    },
    {
      id: 2,
      name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      price: 100.9,
      originalPrice: 160,
      image: "carousel/carslider.png",
    },
    {
      id: 3,
      name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      price: 100.9,
      originalPrice: 160,
      image: "carousel/car2.png",
    },
    {
      id: 4,
      name: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      price: 100.9,
      originalPrice: 160,
      image: "carousel/car3.png",
    },
  ]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const toggleDrawer = (state) => () => {
    setOpen(state);
  };

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    if (selectedItem) {
      setCartItems(cartItems.filter((item) => item.id !== selectedItem.id));
    }
    setDeleteDialogOpen(false);
    setSelectedItem(null);
  };

  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setSelectedItem(null);
  };

  const shippingFee = 32.21;
  const total = cartItems.reduce((sum, item) => sum + item.price, 0) + shippingFee;

  return (
    <div>
      <Button variant="contained" onClick={toggleDrawer(true)}>
        Cart
      </Button>

      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        <Box width={450} padding={2}>
          <Typography variant="h6" gutterBottom>
            My Shopping Cart ({cartItems.length})
          </Typography>
          <Divider />

          {cartItems.map((item) => (
            <Box
              key={item.id}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              my={2}
            >
              <Box display="flex" alignItems="center">
                <img src={item.image} alt={item.name} width={100} height={40} />
                <Box ml={2}>
                  <Typography variant="subtitle1">{item.name}</Typography>
                  <Typography variant="caption">Basic</Typography>
                  <Box sx={{display:"flex", gap:2}}>
                    <Typography variant="subtitle1" color="error">
                      ${item.price.toFixed(2)}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      style={{ textDecoration: "line-through" }}
                    >
                      ${item.originalPrice.toFixed(2)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <IconButton color="error" onClick={() => handleDeleteClick(item)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}
          <Box display="flex" justifyContent="space-between" gap={3} marginTop={5}>
            <TextField
              label="Coupon Code"
              variant="outlined"
              fullWidth
              size="medium"
              margin="normal"
            />
            <Button variant="contained" size="large" boxShadow= "0" sx={{ gap: "2", height: "56px", margin: "16px 0px 25px 0px", backgroundColor: "white", color: "black", width:"160px" }}>
              Apply
            </Button>
          </Box>

          <Divider />

          <Box mt={3}>
            <Box display="flex" justifyContent="space-between">
              <Typography>Shipping Fee</Typography>
              <Typography>${shippingFee.toFixed(2)}</Typography>
            </Box>

            <Box display="flex" justifyContent="space-between" mt={1}>
              <Typography variant="h6">Total</Typography>
              <Typography variant="h6" color="error">
                ${total.toFixed(2)}
              </Typography>
            </Box>
          </Box>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            sx={{ mt: 3, backgroundColor: "red" }}
          >
            Buy Now
          </Button>

          <Button
            variant="contained"
            // color="secondary"
            fullWidth
            size="large"
            sx={{ mt: 2, color: "black", backgroundColor: "white" }}
            onClick={toggleDrawer(false)}
          >
            Continue Shopping
          </Button>
        </Box>
      </Drawer>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCancelDelete}
        aria-labelledby="delete-confirmation-dialog"
      >
        <DialogTitle id="delete-confirmation-dialog">
          Confirm Deletion
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this item from the cart?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="secondary">
            Move To Favourite
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CartDrawer;